import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_URL } from "../utils/constants";
import { showToast } from "../utils/toast";
import PasswordInput from "../Components/PasswordInput";
import "./Login.css";

export default function UpdatePassword() {
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { tokenHash } = useParams();
  const navigate = useNavigate();

  const resetErrorState = () => {
    setTimeout(() => {
      setMessage("");
      setIsError(false);
    }, 3000);
  };

  useEffect(() => {
    if (message) {
      showToast(message, { type: isError ? "error" : "success" });
    }
  }, [message, isError]);

  const handleUpdatePassword = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      setMessage("Please fill in all fields");
      setIsError(true);
      resetErrorState();
      return;
    }

    if (password !== confirmPassword) {
      setMessage("Passwords do not match");
      setIsError(true);
      resetErrorState();
      return;
    }

    if (password.length < 6) {
      setMessage("Password must be at least 6 characters long");
      setIsError(true);
      resetErrorState();
      return;
    }

    try {
      const response = await fetch(`${API_URL}/users/updatePassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          tokenHash,
          password,
        }),
      });

      const data = await response.json();
      if (response.status === 200 || response.status === 201) {
        setMessage(data.message || "Password updated successfully. You can now login with your new password.");
        setIsError(false);
        resetErrorState();
        // Redirect to login after 2 seconds
        setTimeout(() => {
          navigate("/loginregister");
        }, 2000);
      } else {
        setMessage(data.message || "Failed to update password. The link may have expired.");
        setIsError(true);
        resetErrorState();
      }
    } catch (error) {
      setMessage("Failed to update password. Please try again.");
      setIsError(true);
      resetErrorState();
    }
  };

  return (
    <div className="min-h-full flex-col bg-gradient-custom">
      <div className="flex min-h-dvh flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm flex flex-col items-center gap-2 sm:gap-3">
          <img
            src="/logo192.png"
            alt="Seymour Logo"
            className="mx-auto h-11 sm:h-20 w-auto rounded-full"
          />
          <h1 className="text-center text-4xl sm:text-5xl font-extrabold text-white atkinson-font">
            Seymour Events
          </h1>
          <h2 className="text-center text-lg font-extrabold text-white">
            Reset Your Password
          </h2>
          <p className="mt-6 sm:mt-8 text-center text-white atkinson-font w-full">
            Enter your new password below.
          </p>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-xl">
          <form onSubmit={handleUpdatePassword} method="POST" className="space-y-6 mx-4">
            <div>
              <label
                htmlFor="password"
                className="block text-2xl font-bold text-white text-left atkinson-font"
              >
                New Password
              </label>
              <div className="mt-2">
                <PasswordInput
                  id="password"
                  name="password"
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
                  required
                  autoComplete="new-password"
                  placeholder="Enter your new password"
                  className="block w-full rounded-md border border-[#FFFFFFCC] py-2 px-3 bg-[#595959] text-[#FFFFFF] text-sm placeholder:text-[#FFFFFFCC] placeholder:text-gray-400 focus:border-[#FFFFFF]"
                />
              </div>
            </div>

            <div>
              <label
                htmlFor="confirmPassword"
                className="block text-2xl font-bold text-white text-left atkinson-font"
              >
                Confirm Password
              </label>
              <div className="mt-2">
                <PasswordInput
                  id="confirmPassword"
                  name="confirmPassword"
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  value={confirmPassword}
                  required
                  autoComplete="new-password"
                  placeholder="Confirm your new password"
                  className="block w-full rounded-md border border-[#FFFFFFCC] py-2 px-3 bg-[#595959] text-[#FFFFFF] text-sm placeholder:text-[#FFFFFFCC] placeholder:text-gray-400 focus:border-[#FFFFFF]"
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="flex w-full justify-center rounded-md !bg-[#5701AE] p-2 text-base font-semibold text-white hover:!bg-[#7A2FD3]"
                style={{ border: "2px solid #6A6680" }}
              >
                Update Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
